module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "button-create-container"
  }, [(_vm.btnFunction) ? _c('button', {
    staticClass: "button-create",
    staticStyle: {
      "justify-content": "center !important"
    },
    attrs: {
      "type": "button",
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.functionClick
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', {
    staticClass: "ml-2"
  }, [_vm._v(" " + _vm._s(_vm.text))])]) : _c('button', {
    staticClass: "button-create"
  }, [_c('router-link', {
    attrs: {
      "to": _vm.href
    }
  }, [_c('span', {
    staticClass: "icon"
  }, [_vm._v("+")]), _vm._v(" "), _c('span', [_vm._v(" " + _vm._s(_vm.text))])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6a0542ee","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/ButtonCreate.vue
// module id = 751
// module chunks = 108